import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import styled from "styled-components"

const StyledLink = styled(Link)({
  background: `#222A3F`,
  border: `1px solid #222A3F`,
  borderRadius: `0`,
  fontStyle: `normal`,
  fontWeight: `800`,
  textTransform: "none",
  fontSize: `14px`,
  lineHeight: `1.2`,
  color: `#FFFFFF`,
  textDecoration: `none`,
  padding: `0.45rem 1rem`,
})

const StyledA = styled.a({
  background: `#222A3F`,
  border: `1px solid #222A3F`,
  borderRadius: `0`,
  fontStyle: `normal`,
  fontWeight: `800`,
  textTransform: "none",
  fontSize: `14px`,
  lineHeight: `1.2`,
  color: `#FFFFFF`,
  textDecoration: `none`,
  padding: `0.45rem 1rem`,
})

const Button = ({
  children = null,
  to = '',
  className = null,
  ariaLabel = null,
}) => {
  to = to || '';
  return (
    <>
      {to.match(/^https?:/) ? (
        <StyledA href={to} className={className} aria-label={ariaLabel}>
          {children}
        </StyledA>
      ) : (
        <StyledLink to={to} className={className} aria-label={ariaLabel}>
          {children}
        </StyledLink>
      )}
    </>
  )
}

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  to: PropTypes.string,
  id: PropTypes.string,
  ariaLabel: PropTypes.string,
}

export default Button
